import { render, staticRenderFns } from "./InternalAppointmentRecapForm.vue?vue&type=template&id=22d2a7e5"
import script from "./InternalAppointmentRecapForm.vue?vue&type=script&lang=ts"
export * from "./InternalAppointmentRecapForm.vue?vue&type=script&lang=ts"
import style0 from "./InternalAppointmentRecapForm.vue?vue&type=style&index=0&id=22d2a7e5&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports